import {
  AddNewLineAfterInBodyBold,
  ConvertInBodyBoldIntoHeading,
  ConvertInBodyList,
  ConvertStartingBoldIntoHeading,
  ExpandInlineListItems,
  FirstHeadingMustBeH2,
  FixBoldInlineTextSpaces,
  FixBoldListSpaces,
  fixString,
  FixTableSyntax,
  type IConfig,
  MD,
  NoHeadingWithName,
  NoLowerCaseInHeading,
  RemoveImageInBody,
  RemoveListAfterBoldHeading,
  RemoveMDOperatorsFromHeading,
  TrimlineAfterNewLine,
} from '@mahawi/markdown-linter';

export function createMdLinterConfig(brandName?: string | null): IConfig {
  return {
    siblingsOnly: true,
    lineLength: 20000,
    ignored: [MD.MD041, MD.MD047],
    customRules: [
      RemoveListAfterBoldHeading,
      TrimlineAfterNewLine,
      RemoveImageInBody,
      RemoveMDOperatorsFromHeading,
      FixBoldListSpaces,
      AddNewLineAfterInBodyBold,
      ConvertInBodyList,
      FirstHeadingMustBeH2,
      NoHeadingWithName,
      ConvertInBodyBoldIntoHeading,
      ConvertStartingBoldIntoHeading,
      NoLowerCaseInHeading,
      ExpandInlineListItems,
      FixTableSyntax,
      FixBoldInlineTextSpaces,
    ],
    customRulesConfig: {
      noHeadingWithName: {
        forbiddenNames: brandName ? [brandName] : [],
      },
    },
  };
}

export function fixProductDescription(
  description: string | null,
  brandName?: string | null,
): string | null {
  if (!description) return description;
  return fixString(description, createMdLinterConfig(brandName)).content;
}
